import React from 'react';
export const Globe = () => (
  <svg width="201px" height="160px" viewBox="0 0 201 160" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-516.000000, -737.000000)">
        <g transform="translate(516.000000, 737.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M176.1978,153.3324 L144.4518,153.3324"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.3662,153.3324 L38.6102,153.3324"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.6104,153.3324 L20.5734,153.3324"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.8091,145.9369 C91.8091,148.6169 87.4731,147.8249 87.4731,147.8249 L87.4731,126.0349 L91.8091,126.0349 L91.8091,145.9369 Z"
            fill="#F2F3F3"
          />
          <path
            d="M89.6241,154.9594 C89.6241,156.4324 85.7901,157.6254 81.0611,157.6254 C76.3321,157.6254 72.4981,156.4324 72.4981,154.9594 C72.4981,153.4874 76.3321,152.2944 81.0611,152.2944 C85.7901,152.2944 89.6241,153.4874 89.6241,154.9594"
            fill="#D0D7DA"
          />
          <path
            d="M129.1343,156.0697 C129.1343,158.1537 121.7693,159.8437 112.6853,159.8437 C103.6013,159.8437 96.2363,158.1537 96.2363,156.0697 C96.2363,153.9847 103.6013,152.2947 112.6853,152.2947 C121.7693,152.2947 129.1343,153.9847 129.1343,156.0697"
            fill="#D0D7DA"
          />
          <path
            d="M106.5474,123.5815 C106.5474,124.0635 106.1564,124.4555 105.6734,124.4555 C105.1914,124.4555 104.7994,124.0635 104.7994,123.5815 C104.7994,123.0995 105.1914,122.7075 105.6734,122.7075 C106.1564,122.7075 106.5474,123.0995 106.5474,123.5815"
            fill="#D62793"
          />
          <path
            d="M56.5074,113.7104 L56.5074,115.4604"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M56.5074,118.9604 L56.5074,120.7104"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M60.0074,117.2104 L58.2574,117.2104"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M54.7574,117.2104 L53.0074,117.2104"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M137.5489,72.3012 C144.8319,79.0252 149.3929,88.6532 149.3929,99.3462 C149.3929,119.6712 132.9159,136.1482 112.5909,136.1482 C102.8299,136.1482 93.9559,132.3472 87.3689,126.1452"
            stroke="#83291B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.4732,126.0346 L137.5462,72.3056"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M123.5728,154.4985 L101.6748,154.4985 C101.0628,154.4985 100.5678,154.0025 100.5678,153.3915 L100.5678,151.1975 C100.5678,150.5865 101.0628,150.0905 101.6748,150.0905 L123.5728,150.0905 C124.1838,150.0905 124.6798,150.5865 124.6798,151.1975 L124.6798,153.3915 C124.6798,154.0025 124.1838,154.4985 123.5728,154.4985"
            fill="#83291B"
          />
          <path
            d="M144.8565,99.3461 C144.8565,117.1661 130.4105,131.6121 112.5905,131.6121 C94.7715,131.6121 80.3255,117.1661 80.3255,99.3461 C80.3255,81.5271 94.7715,67.0811 112.5905,67.0811 C130.4105,67.0811 144.8565,81.5271 144.8565,99.3461"
            fill="#FFFFFF"
          />
          <path
            d="M144.8565,99.3461 C144.8565,117.1661 130.4105,131.6121 112.5905,131.6121 C94.7715,131.6121 80.3255,117.1661 80.3255,99.3461 C80.3255,81.5271 94.7715,67.0811 112.5905,67.0811 C130.4105,67.0811 144.8565,81.5271 144.8565,99.3461 Z"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M125.3101,110.811 C113.5141,124.166 98.1391,129.861 90.9711,123.53 C83.8031,117.198 87.5551,101.239 99.3521,87.882 C111.1481,74.527 126.5221,68.832 133.6901,75.164 C140.8591,81.495 137.1071,97.455 125.3101,110.811"
            fill="#FFFFFF"
          />
          <path
            d="M125.3101,110.811 C113.5141,124.166 98.1391,129.861 90.9711,123.53 C83.8031,117.198 87.5551,101.239 99.3521,87.882 C111.1481,74.527 126.5221,68.832 133.6901,75.164 C140.8591,81.495 137.1071,97.455 125.3101,110.811 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="136.3999 121.1205 113.0809 99.7565 88.8199 77.5305"
          />
          <path
            d="M134.4566,75.6215 L90.5736,122.7075"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M102.9463,68.5483 L144.8563,107.7383"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.6411,92.183 L122.4951,130.059"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.8565,99.3461 C144.8565,117.1661 130.4105,131.6121 112.5905,131.6121 C94.7715,131.6121 80.3255,117.1661 80.3255,99.3461 C80.3255,81.5271 94.7715,67.0811 112.5905,67.0811 C130.4105,67.0811 144.8565,81.5271 144.8565,99.3461 Z"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.7354,130.7924 C77.3274,127.8934 76.5404,125.8554 77.4864,122.7744 C77.7384,123.0814 77.9904,123.3874 78.2424,123.6934 C78.8044,120.8954 79.4854,118.0754 80.8714,115.5804 C82.2584,113.0854 84.4434,110.9174 87.1834,110.1174 C89.8854,109.3284 93.1874,109.7754 95.1304,107.7384 C95.1994,108.9074 94.5284,110.0874 93.4884,110.6244 C97.4084,112.0504 100.3094,115.9304 100.5674,120.0924 C98.8484,118.9224 96.4444,117.7704 94.8744,119.1324 C93.1394,120.6384 92.3144,123.5664 91.4554,125.6974 C91.0394,126.7304 90.1604,127.5064 89.2344,128.1234 C88.0504,128.9134 86.7384,129.5114 85.3664,129.8864 C84.5584,130.1074 83.3964,129.9164 80.7484,133.0874"
            fill="#8230DF"
          />
          <path
            d="M92.6343,144.3705 C92.6343,141.1485 88.2013,140.7155 86.4513,138.8995 C84.7003,137.0835 84.7613,136.1165 84.7613,136.1165 L77.2023,136.0545 C77.2023,136.0545 77.1923,136.9665 75.4923,138.8995 C73.7933,140.8325 69.3093,140.5695 69.3093,144.3705 C69.3093,148.1715 71.8163,154.4425 71.8163,154.4425 L90.1273,154.4425 C90.1273,154.4425 92.6343,149.1385 92.6343,144.3705"
            fill="#FFFFFF"
          />
          <path
            d="M92.6343,144.3705 C92.6343,141.1485 88.2013,140.7155 86.4513,138.8995 C84.7003,137.0835 84.7613,136.1165 84.7613,136.1165 L77.2023,136.0545 C77.2023,136.0545 77.1923,136.9665 75.4923,138.8995 C73.7933,140.8325 69.3093,140.5695 69.3093,144.3705 C69.3093,148.1715 71.8163,154.4425 71.8163,154.4425 L90.1273,154.4425 C90.1273,154.4425 92.6343,149.1385 92.6343,144.3705 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="75.334 136.444 86.574 136.444 86.574 134.39 75.334 134.39"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="75.334 136.444 86.574 136.444 86.574 134.39 75.334 134.39"
          />
          <path
            d="M81.0537,132.5639 C80.8997,131.3709 81.7677,127.3129 83.6187,123.3209 C85.0357,120.2659 87.0287,117.2509 89.5797,115.5879"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <g transform="translate(55.000000, 35.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.3081 2.1967 4.3371 0.1007 8.0811 2.1967"
            />
            <polyline
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.3081 2.1967 4.3371 0.1007 8.0811 2.1967"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="43.017 61.51 75.373 61.51 75.373 37.906 43.017 37.906"
          />
          <g transform="translate(43.000000, 37.710000)">
            <polyline
              fill="#F3F4F6"
              points="0.0166 7.8304 0.0166 0.1964 32.3726 0.1964 32.3726 41.7474 0.0166 41.7474 0.0166 14.8164"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.0166 7.8304 0.0166 0.1964 32.3726 0.1964 32.3726 41.7474 0.0166 41.7474 0.0166 14.8164"
            />
          </g>
          <polygon
            fill="#F3F4F6"
            points="59.7149 40.9154 45.6419 40.9154 45.6419 52.0264"
          />
          <polygon
            fill="#391572"
            points="74.689 149.138 87.624 149.138 87.624 144.325 74.689 144.325"
          />
          <g transform="translate(112.000000, 135.710000)">
            <path d="M0.5909,0.4379 L0.5909,13.3799" fill="#FFFFFF" />
            <path
              d="M0.5909,0.4379 L0.5909,13.3799"
              stroke="#83291B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#F3F4F6"
            points="47.739 74.677 70.65 74.677 70.65 42.687 47.739 42.687"
          />
          <polygon
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="47.739 74.677 70.65 74.677 70.65 42.687 47.739 42.687"
          />
          <path
            d="M66.0191,86.5111 L66.0191,87.8261"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M66.0191,90.4574 L66.0191,91.7734"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M68.6504,89.142 L67.3344,89.142"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M64.7032,89.142 L63.3882,89.142"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M112.439,108.0785 L112.439,109.3945"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M112.439,112.0258 L112.439,113.3408"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M115.0703,110.7104 L113.7543,110.7104"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M111.1231,110.7104 L109.8081,110.7104"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M76.1822,106.3813 C76.1822,106.8633 75.7912,107.2543 75.3082,107.2543 C74.8262,107.2543 74.4342,106.8633 74.4342,106.3813 C74.4342,105.8983 74.8262,105.5073 75.3082,105.5073 C75.7912,105.5073 76.1822,105.8983 76.1822,106.3813"
            fill="#0B9CE5"
          />
          <polygon
            fill="#E2E8EE"
            points="77.4619 136.9838 84.4209 136.9838 85.1869 138.3368 77.0729 137.6608"
          />
          <g transform="translate(56.000000, 55.710000)">
            <path d="M3.1949,0.1595 L0.5069,2.9725" fill="#F3F4F6" />
            <path
              d="M3.1949,0.1595 L0.5069,2.9725"
              stroke="#DCE4E7"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(59.000000, 55.710000)">
            <path d="M4.3877,0.1595 L0.1947,4.3295" fill="#F3F4F6" />
            <path
              d="M4.3877,0.1595 L0.1947,4.3295"
              stroke="#DCE4E7"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
